import { Expose } from 'class-transformer';
import { Validate } from 'class-validator';

export type CarClassMapping = Record<string, Record<string, string[]>>;

export default class CarsCategoryModel {
    @Expose()
    categories!: CarClassMapping;
}
